<template>
    <div class="light-grad-news"></div>
    <div class="io-container tw-relative tw-z-[1] tw-grid tw-grid-cols-12">
        <section class="tw-col-span-12 tw-border-gray-700 max-xl:tw-border-b max-xl:tw-pb-6 xl:tw-col-span-8 xl:tw-border-r xl:tw-pr-10">
            <section v-if="news">
                <div
                    v-if="news.getMainTag()?.name"
                    class="tw-mb-6 tw-w-fit tw-rounded-full tw-bg-primary tw-px-4 tw-py-2 tw-text-sm tw-font-light tw-text-white xl:tw-mb-8 xl:tw-px-10 xl:tw-py-3 xl:tw-text-lg">
                    {{ news.getMainTag()?.name }}
                </div>
                <h1
                    class="tw-font-title tw-mb-3 tw-text-left tw-text-xl tw-font-bold tw-text-dark xl:tw-text-3xl"
                    v-html="news.title"></h1>
                <div class="tw-mb-5 tw-text-left tw-text-sm tw-font-light tw-text-dark xl:tw-text-base">{{ news.getPublishDate() }}</div>
                <div class="tw-mx-auto tw-mb-5 tw-w-full tw-overflow-hidden tw-rounded-xl xl:tw-rounded-3xl">
                    <v-img
                        class="tw-aspect-[16/9] tw-w-full xl:tw-aspect-[20/9]"
                        cover
                        :src="news.getImage('original')">
                        <slot></slot>
                    </v-img>
                </div>
                <div
                    class="blog-content"
                    v-html="news.content"></div>
            </section>
            <section
                v-else-if="error"
                class="io-container">
                <div class="tw-text-red-500 tw-text-center">
                    <h2>{{ $t('news.errorLoadingNews') }}</h2>
                    <p>{{ error }}</p>
                </div>
            </section>
            <section
                v-else
                class="io-container">
                <div class="tw-flex tw-min-h-[200px] tw-items-center tw-justify-center">
                    <v-progress-circular
                        color="primary"
                        indeterminate
                        size="64">
                    </v-progress-circular>
                </div>
            </section>
        </section>
        <section class="tw-col-span-12 max-xl:tw-pt-6 xl:tw-col-span-4 xl:tw-pl-8">
            <div class="tw-sticky tw-top-0">
                <template v-if="news">
                    <h4 class="tw-mb-4 tw-font-semibold tw-text-dark xl:tw-mb-6 tw-text-xl lg:tw-text-2xl">{{ $t('news.shareArticle') }}</h4>
                    <div class="tw-mb-8 tw-flex tw-justify-start tw-gap-4">
                        <v-btn
                            color="white"
                            elevation="2"
                            icon
                            @click="shareNews('facebook')">
                            <img
                                class="tw-size-6"
                                src="@/assets/icons/facebook.svg" />
                        </v-btn>
                        <v-btn
                            color="white"
                            elevation="2"
                            icon
                            @click="shareNews('x')">
                            <img
                                class="tw-size-5"
                                src="@/assets/icons/x.svg" />
                        </v-btn>
                        <v-btn
                            color="white"
                            elevation="2"
                            icon
                            @click="shareNews('linkedin')">
                            <img
                                class="tw-size-5"
                                src="@/assets/icons/linkedin.svg" />
                        </v-btn>
                        <v-btn
                            color="white"
                            elevation="2"
                            icon
                            @click="shareNews('whatsapp')">
                            <img
                                class="tw-size-6"
                                src="@/assets/icons/whatsapp.svg" />
                        </v-btn>
                    </div>
                </template>
                <NewsletterSmall class="tw-mb-8" />
                <template v-if="news?.getTags()?.length">
                    <h4 class="tw-mb-4 tw-font-semibold tw-text-dark xl:tw-mb-6 tw-text-xl lg:tw-text-2xl">{{ $t('news.otherTags') }}</h4>
                    <div class="tw-mb-12 tw-flex tw-flex-wrap tw-gap-4">
                        <v-btn
                            v-for="tag in news.getTags()"
                            :key="tag.id"
                            class="tw-px-4 tw-py-1 xl:tw-px-5 xl:tw-py-2"
                            color="primary"
                            elevation="0"
                            flat
                            rounded="pill"
                            :to="{ name: 'AllNews', query: { tag: tag.slug } }"
                            variant="outlined">
                            <span class="tw-text-sm tw-font-normal tw-text-dark xl:tw-text-base">{{ tag.name }}</span>
                        </v-btn>
                    </div>
                </template>
                <h4 class="tw-mb-4 tw-font-semibold tw-text-dark xl:tw-mb-8 tw-text-xl lg:tw-text-2xl">{{ $t('news.latestArticles') }}</h4>
                <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-8 xl:tw-mb-8">
                    <NewsHorizontalCard
                        v-for="news in recentNews"
                        :key="news.id"
                        :news="news" />
                </div>
            </div>
        </section>
    </div>
    <div
        v-if="news?.getMainTag()"
        class="io-container">
        <div class="tw-flex tw-justify-between max-xl:tw-flex-col xl:tw-items-center">
            <h2 class="tw-font-title tw-mb-3 tw-text-left tw-font-bold tw-text-dark">
                {{ $t('news.moreArticlesAbout') }} <span class="tw-text-blue">{{ news?.getMainTag()?.name }}</span>
            </h2>
            <v-btn
                class="tw-text-sm max-xl:tw-ms-auto xl:tw-text-base"
                color="blue"
                elevation="0"
                flat
                :to="{ name: 'AllNews', query: { tag: news?.getMainTag()?.slug } }"
                variant="text">
                <span class="tw-mr-3">{{ $t('news.seeAll') }}</span>
                <v-icon>mdi-arrow-top-right</v-icon>
            </v-btn>
        </div>
        <div
            v-if="relatedNews.length"
            class="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-x-8 tw-gap-y-16 max-lg:tw-hidden sm:tw-grid-cols-2 lg:tw-grid-cols-3">
            <NewsCard
                v-for="relatedItem in relatedNews"
                :key="relatedItem.id"
                :news="relatedItem" />
        </div>
        <div
            v-if="relatedNews.length"
            class="tw-mt-10 tw-flex tw-flex-col tw-gap-8 lg:tw-hidden">
            <NewsHorizontalCard
                v-for="relatedItem in relatedNews"
                :key="relatedItem.id"
                :news="relatedItem" />
        </div>
    </div>
    <NewsletterFooter />
</template>

<script setup lang="ts">
    import { getNews, getNewsByTag } from '@/api/news';
    import { useRoute } from 'vue-router';
    import NewsletterSmall from '@/components/NewsletterSmall.vue';
    import { News, useNews } from '@/composables/useNews';
    import { useAppStore } from '@/store/app';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const route = useRoute();
    const appStore = useAppStore();
    const _news = ref<News | null>(null);
    const relatedNews = ref<News[]>([]);
    const error = ref<string | null>(null);

    const news = computed(() => {
        return _news.value ? useNews(_news.value) : null;
    });

    const recentNews = computed(() => {
        const recent = appStore.getRecentNews(5);
        // remove the current news from the recent news
        return recent.filter((news: News) => news.id !== _news.value?.id);
    });

    async function init() {
        try {
            const res = await getNews(route.params.documentId as string);
            const newsArray = res.data.data as News[];
            _news.value = newsArray.find((news: News) => news.slug === route.params.documentId) || newsArray[0];
            document.title = _news.value?.title + ' - IOTech';
            await fetchRelatedNews();
        } catch (err) {
            console.error('Failed to load news:', err);
            error.value = t('news.errorLoadingNewsTryAgain');
        }
    }

    function shareNews(social: 'facebook' | 'x' | 'linkedin' | 'whatsapp') {
        const url = encodeURIComponent(window.location.href);
        const title = encodeURIComponent(news.value?.title || '');
        const description = encodeURIComponent(news.value?.description || '');

        switch (social) {
            case 'facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
                break;
            case 'x':
                window.open(`https://x.com/share?url=${url}`, '_blank');
                break;
            case 'linkedin':
                window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${description}&source=IOTech`, '_blank');
                break;
            case 'whatsapp':
                window.open(`https://wa.me/?text=${url}`, '_blank');
                break;
            default:
                break;
        }
    }

    async function fetchRelatedNews() {
        if (!news.value?.getMainTag()?.slug) return;
        try {
            const res = await getNewsByTag({ tag: news.value?.getMainTag()?.slug as string, limit: 3, documentId: news.value?.documentId as string });
            relatedNews.value = res.data.data;
        } catch (err) {
            console.error('Failed to load related news:', err);
        }
    }

    watch(
        () => route.params.documentId,
        () => {
            if (route.params.documentId) {
                init();
            }
        },
    );

    init();
</script>

<style scoped lang="scss"></style>

<style lang="scss">
    .blog-content {
        word-wrap: break-word;
        --wp--preset--color--black: #000000;
        --wp--preset--color--cyan-bluish-gray: #abb8c3;
        --wp--preset--color--white: #ffffff;
        --wp--preset--color--pale-pink: #f78da7;
        --wp--preset--color--vivid-red: #cf2e2e;
        --wp--preset--color--luminous-vivid-orange: #ff6900;
        --wp--preset--color--luminous-vivid-amber: #fcb900;
        --wp--preset--color--light-green-cyan: #7bdcb5;
        --wp--preset--color--vivid-green-cyan: #00d084;
        --wp--preset--color--pale-cyan-blue: #8ed1fc;
        --wp--preset--color--vivid-cyan-blue: #0693e3;
        --wp--preset--color--vivid-purple: #9b51e0;

        figure {
            @apply tw-mb-[1em];
        }

        figure,
        iframe {
            @apply tw-mx-auto tw-w-full tw-max-w-full tw-text-center;
        }

        img {
            border: none;
            border-radius: 0;
            box-shadow: none;
            height: auto;
            max-width: 100%;
        }

        :before {
            box-sizing: border-box;
        }

        iframe[src*='youtube.com'] {
            /* Your styles here */
            aspect-ratio: 16 / 9;
            border: none;
            border-radius: 0;
            box-shadow: none;
            height: 100%;
            max-width: 100%;
            width: 100%;
        }

        h2 {
            @apply tw-text-xl tw-font-medium tw-mb-4 tw-text-left #{!important};
        }

        figure.tiled-gallery__item {
            img {
                flex: 1 0 0%;
                height: 100%;
                object-fit: contain;
                width: 100%;
                max-width: 1024px;
                max-height: max(40vh, 100px);
                margin-inline: auto;
            }
        }

        figure {
            &.wp-block-image {
                border-radius: 10px;
                overflow: hidden;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                justify-content: center;
                max-width: 100%;
                position: relative;
                width: 100%;

                figcaption:before {
                    backdrop-filter: blur(3px);
                    content: '';
                    height: 100%;
                    mask-image: linear-gradient(0deg, #000 20%, #0000);
                    max-height: 100%;
                    bottom: 0;
                    left: 0;
                    position: absolute;
                    right: 0;
                    z-index: -1;
                }

                img {
                    flex: 1 0 0%;
                    height: 100%;
                    object-fit: contain;
                    width: 100%;
                    max-width: 1024px;
                    max-height: 90vh;
                    margin-inline: auto;
                }

                figcaption {
                    background: linear-gradient(0deg, #0006, #0000);
                    box-sizing: border-box;
                    color: #fff;
                    font-size: 13px;
                    margin: 0;
                    overflow: auto;
                    padding: 1em;
                    scrollbar-color: #0000 #0000;
                    scrollbar-gutter: stable both-edges;
                    scrollbar-width: thin;
                    text-align: center;
                    text-shadow: 0 0 1.5px #000;
                    will-change: transform;
                    bottom: 0;
                    left: 0;
                    max-height: 100%;
                    position: absolute;
                    right: 0;
                    line-height: 1.25;
                }
            }
            &.wp-block-gallery {
                align-items: normal;
                display: flex;
                flex-wrap: wrap;
                gap: 1rem;

                figure.wp-block-image:not(#individual-image) {
                    width: calc(100% - var(--wp--style--unstable-gallery-gap, 16px) * 0.66667);
                }

                figure.wp-block-image:not(#individual-image):first-child:nth-last-child(2),
                figure.wp-block-image:not(#individual-image):first-child:nth-last-child(2) ~ figure.wp-block-image:not(#individual-image) {
                    width: calc(100% - var(--wp--style--unstable-gallery-gap, 16px) * 0.5);
                }

                .blocks-gallery-grid {
                    @apply tw-mx-auto tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2;

                    figure {
                        @apply tw-aspect-video;

                        img {
                            @apply tw-h-full tw-w-full tw-object-cover;
                        }
                    }
                }
            }
        }

        .has-black-color {
            color: var(--wp--preset--color--black) !important;
        }

        .has-cyan-bluish-gray-color {
            color: var(--wp--preset--color--cyan-bluish-gray) !important;
        }

        .has-white-color {
            color: var(--wp--preset--color--white) !important;
        }

        .has-pale-pink-color {
            color: var(--wp--preset--color--pale-pink) !important;
        }

        .has-vivid-red-color {
            color: var(--wp--preset--color--vivid-red) !important;
        }

        .has-luminous-vivid-orange-color {
            color: var(--wp--preset--color--luminous-vivid-orange) !important;
        }

        .has-luminous-vivid-amber-color {
            color: var(--wp--preset--color--luminous-vivid-amber) !important;
        }

        .has-light-green-cyan-color {
            color: var(--wp--preset--color--light-green-cyan) !important;
        }

        .has-vivid-green-cyan-color {
            color: var(--wp--preset--color--vivid-green-cyan) !important;
        }

        .has-pale-cyan-blue-color {
            color: var(--wp--preset--color--pale-cyan-blue) !important;
        }

        .has-vivid-cyan-blue-color {
            color: var(--wp--preset--color--vivid-cyan-blue) !important;
        }

        .has-vivid-purple-color {
            color: var(--wp--preset--color--vivid-purple) !important;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            margin-block-start: 0.5rem;
            margin-block-end: 1rem;
            font-family: inherit;
            font-weight: 500;
            line-height: 1.2;
            color: inherit;
        }

        h2 {
            font-size: 2rem;
        }

        p {
            margin-block-start: 0;
            margin-block-end: 0.9rem;
        }

        a[href] {
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>
